import { createContext, useContext, useState } from "react";
import { translations } from "@/i18n";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("es");
  const t = translations[lang];
  const toggle = () => setLang((p) => (p === "es" ? "en" : "es"));
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);

// Helper: resolve a value that may be a plain string or {es,en} object
export const tx = (value, lang) =>
  value && typeof value === "object" ? value[lang] : value;
